<div class="contentWrapper">
    <div class="logo">
        <div class="Wrapper">
            <!-- <span>flowtrics</span> -->
            <a [routerLink]="'/'"><img src="../../../assets/images/logo/flowtrics_logo.png" alt=""></a>
        </div> 
    </div>   
    <div class="Wrapper">
        <h3>Thank You for your Information.</h3>
        <!-- <h5>You will receive an email containing a link to complete the forms requested.</h5> -->
        <h5>Your progress has been saved successfully. You can return anytime using the same link to complete or update your form.

Once you’ve filled all required sections, click "Finish" to submit your final response.

Thank you!</h5>

        <div class="emailImg">
            <img src="../../../assets/images/thanksEmail.png" alt="">
        </div>
        <!-- <a class="register" href="http://flowtrics.com/"  mat-stroked-button color="primary"  type="button">Get Started</a> -->
    </div> 
</div>